import type { Quotation } from '~/api/quotations/types';

import { QuotationStatusTag } from '~/pages/Quotations/QuotationsOverview/QuotationStatusTag';

type Props = {
  quotation: Quotation;
};

export const QuotationStatusCell = ({ quotation }: Props) => {
  return <QuotationStatusTag status={quotation.status} />;
};
